export type CoverageType = 'AVIATION_HULL' | 'AVIATION_LIABILITIES' | 'COMMERCIAL_GENERAL_LIABILITY'

export const COVERAGE_TYPE_ENUM = {
  AviationHull: 'AVIATION_HULL',
  AviationLiabilits: 'AVIATION_LIABILITIES',
  CommercialGeneralLiability: 'COMMERCIAL_GENERAL_LIABILITY',
}
export const COVERAGE_TYPE_OPTIONS = [
  { label: 'Aviation Hull', value: COVERAGE_TYPE_ENUM.AviationHull },
  { label: 'Aviation Liabilities', value: COVERAGE_TYPE_ENUM.AviationLiabilits },
  { label: 'Commercial General Liability', value: COVERAGE_TYPE_ENUM.CommercialGeneralLiability },
]
